import { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
} from "react-bootstrap";

import {
  FaChartLine,
  FaRupeeSign,
  FaBullseye,
  FaShieldAlt,
  FaFlag,
  FaSave,
  FaLayerGroup,
} from "react-icons/fa";

import Header from "../components/Header";

function EditCall() {
  const navigate = useNavigate();
  const location = useLocation();

  const call = location.state;

  const [stockName, setStockName] = useState(call?.stockName || "");
  const [callType, setCallType] = useState(call?.callType || "Long Term");

  const [buyPrice, setBuyPrice] = useState(call?.buyPrice || "");
  const [entryPrice, setEntryPrice] = useState(
    call?.entryPrice || parseFloat(call?.buyPrice) || ""
  );

  const [targetPrice, setTargetPrice] = useState(call?.targetPrice || "");
  const [stopLoss, setStopLoss] = useState(call?.stopLoss || "");

  const [currentPrice, setCurrentPrice] = useState(
    call?.currentPrice ||
      call?.entryPrice ||
      parseFloat(call?.buyPrice) ||
      ""
  );

  const [status, setStatus] = useState(call?.status || "Active");

  const updateCall = async () => {
    if (!call?.id) {
      alert("Something went wrong. Please go back and try again.");
      navigate("/admin-dashboard");
      return;
    }

    if (
      !stockName ||
      !callType ||
      !buyPrice ||
      !entryPrice ||
      !targetPrice ||
      !stopLoss ||
      !currentPrice ||
      !status
    ) {
      alert("Please fill all fields.");
      return;
    }

    const callRef = doc(db, "stockCalls", call.id);

    await updateDoc(callRef, {
      stockName,
      callType,

      // Flexible text values
      // Example: 250, 250-300, Above 900, Below 220
      buyPrice,
      targetPrice,
      stopLoss,

      // Number used only for profit/loss calculation
      entryPrice: Number(entryPrice),

      currentPrice: Number(currentPrice),
      status,
    });

    alert("✅ Stock Call Updated Successfully");

    navigate("/admin-dashboard");
  };

  return (
    <>
      <Header />

      <Container className="mt-4">
        <Row className="justify-content-center">
          <Col lg={9}>
            <Card className="shadow border-0">
              <Card.Body className="p-4">
                <h2 className="fw-bold mb-4">
                  ✏ Edit Stock Call
                </h2>

                <Form>
                  <Row>
                    <Col md={8}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaChartLine className="me-2 text-success" />
                          Stock Name
                        </Form.Label>

                        <Form.Control
                          type="text"
                          value={stockName}
                          onChange={(e) => setStockName(e.target.value)}
                          placeholder="Enter stock name"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaLayerGroup className="me-2 text-primary" />
                          Call Type
                        </Form.Label>

                        <Form.Select
                          value={callType}
                          onChange={(e) => setCallType(e.target.value)}
                        >
                          <option>Long Term</option>
                          <option>Mid Term</option>
                          <option>Short Term</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaRupeeSign className="me-2 text-primary" />
                          Buy Price / Buy Range
                        </Form.Label>

                        <Form.Control
                          type="text"
                          value={buyPrice}
                          onChange={(e) => setBuyPrice(e.target.value)}
                          placeholder="Example: 250-300 / Above 900"
                        />

                        <small className="text-muted">
                          You can enter 350, 350-370, Above 900, etc.
                        </small>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaRupeeSign className="me-2 text-success" />
                          Calculation Price
                        </Form.Label>

                        <Form.Control
                          type="number"
                          value={entryPrice}
                          onChange={(e) => setEntryPrice(e.target.value)}
                          placeholder="Example: 250"
                        />

                        <small className="text-muted">
                          Profit/Loss will be calculated using this price.
                        </small>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          💹 CMP
                        </Form.Label>

                        <Form.Control
                          type="number"
                          value={currentPrice}
                          onChange={(e) =>
                            setCurrentPrice(e.target.value)
                          }
                          placeholder="CMP"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaBullseye className="me-2 text-success" />
                          Target Price / Target Range
                        </Form.Label>

                        <Form.Control
                          type="text"
                          value={targetPrice}
                          onChange={(e) => setTargetPrice(e.target.value)}
                          placeholder="Example: 350-370 / Above 900"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          <FaShieldAlt className="me-2 text-danger" />
                          Stop Loss
                        </Form.Label>

                        <Form.Control
                          type="text"
                          value={stopLoss}
                          onChange={(e) => setStopLoss(e.target.value)}
                          placeholder="Example: 220 / Below 220"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <FaFlag className="me-2 text-primary" />
                      Status
                    </Form.Label>

                    <Form.Select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option>Active</option>
                      <option>Target Hit</option>
                      <option>Stop Loss Hit</option>
                      <option>Exit</option>
                      <option>Closed</option>
                    </Form.Select>
                  </Form.Group>

                  <Row>
                    <Col md={6} className="mb-2">
                      <Button
                        variant="secondary"
                        size="lg"
                        className="w-100"
                        onClick={() => navigate("/admin-dashboard")}
                      >
                        Cancel
                      </Button>
                    </Col>

                    <Col md={6} className="mb-2">
                      <Button
                        variant="success"
                        size="lg"
                        className="w-100"
                        onClick={updateCall}
                      >
                        <FaSave className="me-2" />
                        Update Stock Call
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default EditCall;